var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",staticStyle:{"height":"calc(100vh - 58px)"},attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('p',[_vm._v(_vm._s(_vm.$t("pages.404.headline")))]),_c('v-btn',{attrs:{"to":"/","color":"primary","text":""}},[_vm._v(" "+_vm._s(_vm.$t("pages.404.btn"))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }